import { useAblyAvailable } from 'hb-react/shared/hooks/useAbly';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

const useVirusScanningEnabled = () => {
  const { flagEvVirusScanning } = useFeatureFlag();

  const ablyAvailable = useAblyAvailable();

  const virusScanningEnabled = flagEvVirusScanning && ablyAvailable;

  return virusScanningEnabled;
};

export default useVirusScanningEnabled;
